/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ExtraChargeType} from './ExtraChargeType';
import {OfferProduct} from './OfferProduct';

export interface MarkupBuilder {
  apply(price: number, value: number): number;
  applyAll(products: OfferProduct[], value: number): Map<number, number>;
  getType(): ExtraChargeType;
}
